export abstract class FieldModel {
    public abstract $typeHint: string;
    public id = 0;
    public name = "";
    public required = false;
    public enabled = true;
    public sortOrder = 0;
    public inUse = false;
    public area = "";
}
